import type {CampaignADto} from '@cohort/admin-schemas/campaign';
import NotFoundSection from '@cohort/merchants/components/error-pages/NotFoundSection';
import {useCampaign} from '@cohort/merchants/hooks/api/Campaigns';
import {useUserSessionStore} from '@cohort/merchants/hooks/stores/userSession';
import SkeletonLoader from '@cohort/merchants/layouts/SkeletonLoader';
import {createContext} from 'react';
import {useParams} from 'react-router-dom';

type CurrentCampaignProviderProps = {
  children: React.ReactNode;
};

export const CurrentCampaignContext = createContext<CampaignADto | null>(null);

export const CurrentCampaignProvider: React.FC<CurrentCampaignProviderProps> = ({children}) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const merchantId = useUserSessionStore(store => store.merchantId!);
  const {campaignId} = useParams();

  const {data: campaign, isFetched} = useCampaign(
    merchantId,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    campaignId!,
    {enabled: Boolean(campaignId), refetchOnWindowFocus: false}
  );

  if (campaignId === undefined) {
    return <NotFoundSection />;
  }

  if (isFetched && !campaign) {
    return <NotFoundSection />;
  }

  if (campaign === undefined) {
    return <SkeletonLoader />;
  }

  return (
    <CurrentCampaignContext.Provider value={campaign}>{children}</CurrentCampaignContext.Provider>
  );
};
